import { useEffect } from "react";

export const TITLE_SUFFIX = "RosterPilot";

export const setDocumentTitle = (title: string | null) => {
  document.title = title ? `${title} | ${TITLE_SUFFIX}` : TITLE_SUFFIX;
};

/**
 * Sets the browser tab title for the current screen (WCAG 2.4.2).
 *
 * A single-page app keeps the title from `index.html` forever unless something
 * changes it, so every route announced "rosterpilot-web" and browser history
 * was a wall of identical entries.
 *
 * Use this in pages whose title depends on loaded data (a prospect's name, a
 * roster). Static routes are titled centrally by `RouteTitle`, which skips any
 * path a page titles for itself.
 *
 * Pass `null` while the subject is still loading to show the bare product name
 * rather than flashing a placeholder.
 *
 * There is deliberately no cleanup that restores the previous title: the next
 * route sets its own on mount, and restoring first causes a visible flash of
 * the old name.
 */
export const useDocumentTitle = (title: string | null) => {
  useEffect(() => {
    setDocumentTitle(title);
  }, [title]);
};
